import IfAuth from 'mrf/utils/IfAuth.js'

console.warn("The 'view/IFAuth' component is deprecated, please use 'utils/IfAuth' instead.")
const IFAuth = IfAuth;

export default IFAuth;